'use strict';
import * as $j_app$002edata$002e$002dApp$002dRegistered$002dUser from "./app.data.-App-Registered-User.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppRegisteredUser$PharmacyUser$() {
}
export { $c_Lapp_data_AppRegisteredUser$PharmacyUser$ as $c_Lapp_data_AppRegisteredUser$PharmacyUser$ };
$c_Lapp_data_AppRegisteredUser$PharmacyUser$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppRegisteredUser$PharmacyUser$.prototype.constructor = $c_Lapp_data_AppRegisteredUser$PharmacyUser$;
/** @constructor */
function $h_Lapp_data_AppRegisteredUser$PharmacyUser$() {
}
export { $h_Lapp_data_AppRegisteredUser$PharmacyUser$ as $h_Lapp_data_AppRegisteredUser$PharmacyUser$ };
$h_Lapp_data_AppRegisteredUser$PharmacyUser$.prototype = $c_Lapp_data_AppRegisteredUser$PharmacyUser$.prototype;
$c_Lapp_data_AppRegisteredUser$PharmacyUser$.prototype.toString__T = (function() {
  return "PharmacyUser";
});
$c_Lapp_data_AppRegisteredUser$PharmacyUser$.prototype.fromProduct__s_Product__Lapp_data_AppRegisteredUser$PharmacyUser = (function(x$0) {
  var pharmacyId$1 = x$0.productElement__I__O(0);
  var name$2 = x$0.productElement__I__O(1);
  var status$1 = x$0.productElement__I__O(2);
  var isAdmin$2 = (!(!x$0.productElement__I__O(3)));
  return new $j_app$002edata$002e$002dApp$002dRegistered$002dUser.$c_Lapp_data_AppRegisteredUser$PharmacyUser(pharmacyId$1, name$2, status$1, isAdmin$2);
});
$c_Lapp_data_AppRegisteredUser$PharmacyUser$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_data_AppRegisteredUser$PharmacyUser(p);
});
var $d_Lapp_data_AppRegisteredUser$PharmacyUser$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppRegisteredUser$PharmacyUser$, "app.data.AppRegisteredUser$PharmacyUser$", ({
  Lapp_data_AppRegisteredUser$PharmacyUser$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_data_AppRegisteredUser$PharmacyUser$ as $d_Lapp_data_AppRegisteredUser$PharmacyUser$ };
var $n_Lapp_data_AppRegisteredUser$PharmacyUser$;
function $m_Lapp_data_AppRegisteredUser$PharmacyUser$() {
  if ((!$n_Lapp_data_AppRegisteredUser$PharmacyUser$)) {
    $n_Lapp_data_AppRegisteredUser$PharmacyUser$ = new $c_Lapp_data_AppRegisteredUser$PharmacyUser$();
  }
  return $n_Lapp_data_AppRegisteredUser$PharmacyUser$;
}
export { $m_Lapp_data_AppRegisteredUser$PharmacyUser$ as $m_Lapp_data_AppRegisteredUser$PharmacyUser$ };
//# sourceMappingURL=app.data.-App-Registered-User$-Pharmacy-User$.js.map
